var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "1300" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [_c("v-icon", [_vm._v("refresh")]), _vm._v("Movilidad")],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "py-0 px-1" },
            [
              _c(
                "v-container",
                {
                  staticClass: "py-0",
                  staticStyle: { "min-width": "100%" },
                  attrs: { "grid-list-md": "" }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "", row: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("v-select", {
                            staticClass: "text-field-reducido-border",
                            attrs: {
                              items: _vm.tipo_movimientos,
                              "item-text": "descripcion",
                              "item-value": function(val) {
                                return parseInt(val.id)
                              },
                              label: "Tipo de movimiento",
                              rules: _vm.$validate(["required"]),
                              required: "",
                              disabled: !!_vm.movilidad.id,
                              outline: ""
                            },
                            model: {
                              value: _vm.form.id_tipo_justificacion,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "id_tipo_justificacion", $$v)
                              },
                              expression: "form.id_tipo_justificacion"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _vm.form.id_tipo_justificacion == 4
                            ? _c("RetiroPasante", {
                                attrs: {
                                  movilidad: _vm.movilidad,
                                  id_tipo_justificacion:
                                    _vm.form.id_tipo_justificacion
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.id_tipo_justificacion == 3
                            ? _c("IncorporacionPasante", {
                                attrs: {
                                  movilidad: _vm.movilidad,
                                  id_tipo_justificacion:
                                    _vm.form.id_tipo_justificacion
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10f868d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10f868d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/movilidad/dialogs/NuevaMovilidadPasante.vue
// module id = null
// module chunks = 